import SharePop from "@/components/SharePop";
import useTranslation from "@/hooks/useTranslation";
import { ShareAltOutlined } from "@ant-design/icons";
import React from "react";
import styles from "../styles.module.less";

const { itemContainer, itemIcon, itemText } = styles;

interface IProps {
  pmid: string;
  articleTitle: string;
}

const Share: React.FC<IProps> = ({ pmid, articleTitle }) => {
  const { t } = useTranslation("explore");

  return (
    <SharePop
      title={articleTitle}
      url={`https://www.medicgo.org/navigator/paper/${pmid}`}
    >
      <div className={itemContainer}>
        <div className={itemIcon}>
          <ShareAltOutlined />
        </div>
        <div className={itemText}>{t("tab.helper.share")}</div>
      </div>
    </SharePop>
  );
};

export default Share;
